export default __webpack_public_path__ + "static/media/Galaxia-Studios.ad7a9447.png";